import { useSelector } from 'modules/react-redux';

import { getRequestEditMode, RequestEditMode } from '../../../../selectors/requestSelectors';
import { useRequest } from './useRequest';

export const useIsApproverMode = () => {
    const request = useRequest();
    const editMode = useSelector((state) => getRequestEditMode(state, request));

    return editMode === RequestEditMode.Approver;
};
